import type { ITopBanner } from "@/sanity/globals/TopBanner";
import type { IBannerCampaign } from "@/sanity/globals/BannerCampaign";

/** Fixed id of the Banner Campaign singleton. */
export const BANNER_CAMPAIGN_ID = "bannerCampaign";

/** `?campaignPreview=1` forces the campaign live, `=0` forces the standard banner (QA). */
export const CAMPAIGN_PREVIEW_PARAM = "campaignPreview";

export interface IPageTopBanner {
  showTopBanner?: boolean;
  topBanner?: ITopBanner | null;
}

const pick = (enabled: boolean | undefined, banner: ITopBanner | null | undefined) =>
  enabled && banner ? banner : undefined;

/**
 * The top banner a page shows, first match wins:
 * 1. the campaign banner, only while the campaign is live
 * 2. the standard banner on the campaign singleton
 * 3. the page's own banner
 *
 * A tier counts only with its toggle on and its reference filled, so an empty field (or a
 * deleted banner, which resolves to null) falls through to the next one.
 */
export function resolveTopBanner(
  page: IPageTopBanner | null | undefined,
  campaign: IBannerCampaign | null | undefined,
  live: boolean,
): ITopBanner | undefined {
  return (
    (live ? pick(campaign?.showTopBanner, campaign?.topBanner) : undefined) ??
    pick(campaign?.showDefaultTopBanner, campaign?.defaultTopBanner) ??
    pick(page?.showTopBanner, page?.topBanner)
  );
}
